/**
 * @description Content Type
 */
export enum ContentType {

	/**
	 * @description Video content
	 * @type {String}
	 */
	CONTENT = 'CONTENT',

	/**
	 * @description AD
	 * @type {String}
	 */
	AD = 'AD',

	/**
	 * @description Audio content
	 * @type {String}
	 */
	AUDIO = 'AUDIO'

}